import React from 'react';

function DashboardHome() {
  return (
    <h3 style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '85vh'
    }}>
      Welcome
    </h3>
  );
}

export default DashboardHome;